import { connect } from 'react-redux'
import { actions } from 'appRedux/modules/FunPoint'
// import { actions as actionsUserCards } from 'appRedux/modules/UserCards'
import { FunPointForm as component } from './FunPointForm'


const mapStateToProps = (state) => ({ ...state.FunPoint });
const mapDispatchToProps = (dispatch) => ({
    onFunPointCardAddRequest: (data) => dispatch(actions.addFunPointCardRequest(data)),
    onFunPointCardRemoveRequest: (data) => dispatch(actions.removeFunPointCardRequest(data)),
});
const FunPointForm = connect(mapStateToProps, mapDispatchToProps)(component);


export { FunPointForm }
